import script from "./permitDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./permitDetail.vue?vue&type=script&setup=true&lang=js"

import "./permitDetail.vue?vue&type=style&index=0&id=e9048174&lang=css"

const __exports__ = script;

export default __exports__